import { CustomData } from 'features/editor/viewTypes';
import checkIfArray from 'utils/checkIfArray';

import selectItems from '../constants/selectItems';

const getInitialData = ({
  templateType,
  templateVariant = 'VARIANT',
  transition = selectItems[0],
  metaData = [],
  assets = [],
  ...rest
}: CustomData) => ({
  templateType,
  templateVariant,
  transition,
  metaData: checkIfArray(metaData),
  assets: checkIfArray(assets),
  ...rest,
});

export default getInitialData;
